import { connect } from 'react-redux';
import informationModule from 'app/store/information';
import Competition from './Competition.component';

const {
  competitionsRequest,
  setCompetitionsContent,
  competitionEventsRequest
} = informationModule.actions;

const mapStateToProps = ({ information, layout }) => ({
  content: information.competitions,
  competitionEvents: information.competitionEvents,
  isLoading: layout.isLoading
});

const mapDispatchToProps = {
  fetchCompetitionContent: competitionsRequest,
  getCompetitionEvents: competitionEventsRequest,
  clearState: setCompetitionsContent.bind(null, null)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Competition);
